'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slide = exports.Swiper = undefined;

var _Swiper2 = require('./Swiper');

var _Swiper3 = _interopRequireDefault(_Swiper2);

var _Slide2 = require('./Slide');

var _Slide3 = _interopRequireDefault(_Slide2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Swiper = _Swiper3.default;
exports.Slide = _Slide3.default;